// extracted by mini-css-extract-plugin
export default {"wrapper":"FieldModuleBoxWrapper_wrapper__ouBD8"};